"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const benefits = ["Volledige privacy tijdens uw consult", "100% echt haar van de hoogste kwaliteit", "Naadloze integratie met uw eigen haar", "Persoonlijk onderhouds- en stylingadvies"];
export default function HaarwerkenOpMaat() {
  return <section id="haarwerken-op-maat" className="bg-background py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:items-center">
          
          {}
          <div className="flex flex-col justify-center">
            <h2 className="mb-6 font-serif text-4xl font-bold text-foreground md:text-5xl lg:text-6xl">
              Haarwerken op maat
            </h2>
            
            <p className="mb-8 font-sans text-lg leading-relaxed text-muted-foreground">
              Bij VIP Company begrijpen we dat haarverlies een diepgaande impact kan hebben. Daarom bieden wij exclusieve, op maat gemaakte haarwerken in een discrete en luxueuze omgeving. Onze specialisten nemen de tijd om samen met u een oplossing te creëren die perfect aansluit bij uw wensen, stijl en natuurlijke uitstraling, zodat u weer met vol vertrouwen in de spiegel kunt kijken.
            </p>
            
            <ul className="mb-10 space-y-4">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10">
                    <Check className="h-3.5 w-3.5 text-primary" strokeWidth={3} />
                  </div>
                  <span className="font-sans text-base text-foreground">
                    {benefit}
                  </span>
                </li>)}
            </ul>
            
            <div className="flex flex-col gap-4 sm:flex-row">
              <Button size="lg" asChild className="font-medium">
                <Link to="/HomePage">
                  Boek gratis intake
                </Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="font-medium">
                <Link to="/HomePage">
                  Bekijk collectie
                </Link>
              </Button>
            </div>
          </div>
          
          {}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[3/4] w-full overflow-hidden rounded-[12px] shadow-lg lg:aspect-[4/5]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/custom_hairworks_editorial_portrait.png" alt="Vrouw met op maat gemaakt volumineus haarwerk" className="h-full w-full object-cover object-center" />
            </div>
            {}
            <div className="absolute -bottom-6 -left-6 -z-10 h-32 w-32 rounded-full bg-primary/20 blur-3xl"></div>
            <div className="absolute -right-6 -top-6 -z-10 h-40 w-40 rounded-full bg-accent/30 blur-3xl"></div>
          </div>
          
        </div>
      </div>
    </section>;
}